// extracted by mini-css-extract-plugin
export default {"header_head":"text_header_head__i4VyA","header_title":"text_header_title__SGAN3"};